/**
 * Lightweight homepage / storefront performance helpers:
 * - content-visibility for below-fold sections
 * - expose a small visibility helper for section scripts
 */
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function whenVisible(el, callback, options) {
    if (!el || typeof callback !== 'function') return;
    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          callback(entry.target);
        });
      },
      options || { rootMargin: '200px 0px', threshold: 0.01 }
    );
    observer.observe(el);
  }

  window.zaoudWhenVisible = whenVisible;

  function markBelowFoldSections() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = main.querySelectorAll('.shopify-section');
    sections.forEach(function (section, index) {
      if (index < 2) return;
      /* Don't fight wave-reveal (content-visibility breaks IO / layout) */
      if (section.classList.contains('zaoud-reveal-section')) return;
      if (section.classList.contains('zaoud-cv-skip')) return;
      section.classList.add('zaoud-cv-auto');
    });
  }

  function boot() {
    if (!REDUCE) markBelowFoldSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    markBelowFoldSections();
  });
})();
